import { useEffect, useState } from "react";
import { Instagram } from "lucide-react";

const IG_URL = "https://www.instagram.com/dashaloveofficial";

export const DmButton = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 120);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a href={IG_URL} target="_blank" rel="noopener noreferrer" className={`dm-btn${show ? " on" : ""}`} aria-label="Questions? DM me on Instagram" data-testid="instagram-dm-button">
      <Instagram size={18} />
      <span className="dm-long">Questions? DM me</span>
      <span className="dm-short">DM me</span>
    </a>
  );
};
